Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '';
__p += '<div id="' +
((__t = (ctx.mapId)) == null ? '' : __t) +
'" style="min-height: 300px; height: calc(100vh - 600px);" ref="gmapElement"></div>\n';
return __p
}